const API_URL = fileEnv.env.API_URL;

class ServiceRequestApiManager {
    constructor() {
    }

    get(url) {
        return this.execRequest(url, 'GET');
    }

    post(url, body = null) {
        return this.execRequestWithBody(url, 'POST', body);
    }

    put(url, body = null) {
        return this.execRequestWithBody(url, 'PUT', body);
    }

    delete(url, body = null) {
        return this.execRequestWithBody(url, 'DELETE', body);
    }

    async execRequestWithBody(url, type, body = null) {
        let response;
        await fetch(API_URL + url, {
            method: type,
            headers: {
                'Access-Control-Allow-Origin': API_URL,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })
        .then((res) => {
            response = res.ok;
        })
        .catch((err) => {
            response = err.status;
        });
        return response;
    }

    async execRequest(url, type) {
        let response = await fetch(API_URL + url, {
            method: type,
            headers: {
                'Access-Control-Allow-Origin': API_URL,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        return await response.json();
    }
}

let requestApiInstance = null;

export function InitRequestApi() {
    requestApiInstance = new ServiceRequestApiManager();
    return requestApiInstance;
}

export default function GetRequestApiInstance() {
    if (!requestApiInstance) {
        InitRequestApi();
    }
    return requestApiInstance;
}